// src/utils/uploadValidation.js
//
// Centralised file-upload rules used across every upload screen
// (License, Qualification, Achievement, etc). Keeping this in one
// place means changing the size/type limit later only needs one edit.

export const MAX_FILE_SIZE_MB = 2;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

// Images only — jpg, png, webp. Add more mime types here if needed later.
export const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];

export const ALLOWED_EXTENSIONS_LABEL = 'JPG, PNG, or WEBP';

/**
 * Validates a File object against the centralised size/type rules.
 * Returns { valid: true } or { valid: false, reason: string }.
 *
 * Usage:
 *   const result = validateFile(file);
 *   if (!result.valid) { alert(result.reason); return; }
 */
export function validateFile(file) {
    if (!file) {
        return { valid: false, reason: 'No file selected.' };
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
        return {
            valid: false,
            reason: `Unsupported file type. Please upload a ${ALLOWED_EXTENSIONS_LABEL} file.`,
        };
    }

    if (file.size > MAX_FILE_SIZE_BYTES) {
        const sizeMb = (file.size / (1024 * 1024)).toFixed(1);
        return {
            valid: false,
            reason: `File is too large (${sizeMb} MB). Maximum allowed size is ${MAX_FILE_SIZE_MB} MB.`,
        };
    }

    return { valid: true };
}